import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";

export class CreateTransactionManual {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly q_dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(id_bank_account:string, concept:string, bookingDate:string, amount:string, balance_after_transaction, initial_transaction:boolean, listFilters?): Promise<any> {
    let args = { 
      id_bank_account: id_bank_account,
      concept: concept,
      bookingDate: bookingDate,
      amount: parseFloat(amount),
      initial_transaction: initial_transaction
    }
    if (balance_after_transaction){
      args['balance_after_transaction'] = parseFloat(balance_after_transaction)
    }
    try {
      this.frontend.change_loading_add_transaction(true)
      await this.dispatcher.dispatch('create.transaction.manual', args)
      this.frontend.change_loading_add_transaction(false)
      this.frontend.cleanImputs()
      await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(id_bank_account, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
    } catch (error) {
      console.error('Error create transaction manual', error)
    }
    this.frontend.change_loading_add_transaction(false)
  }
}